import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=e7a13d4e&scoped=true&"
import script from "./ModalBase.vue?vue&type=script&lang=ts&"
export * from "./ModalBase.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=e7a13d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a13d4e",
  null
  
)

export default component.exports